//components
import Container from "components/Container";
import SupplierPlan from "./components/SupplierPlan";
import CTAHero from "features/home/components/CTAHero";
import Button from "components/Button";
import { BuildingOffice2Icon, UserIcon } from "@heroicons/react/24/outline";

const tiers = [
  {
    name: "Individual Supplier",
    id: "individual-supplier",
    href: "/supplier-register-individual",
    features: [
      "Access to all basic features",
      "Basic reporting and analytics",
      "Up to 10 individual users",
      "20GB individual data each user",
      "Basic chat and email support",
    ],
  },
  {
    name: "Corporate Supplier",
    id: "corporate-supplier",
    href: "/supplier-register-corporate",
    features: [
      "200+ integrations",
      "Advanced reporting and analytics",
      "Up to 20 individual users",
      "40GB individual data each user",
      "Priority chat and email support",
    ],
  },
];

export default function SupplierRegister() {
  return (
    <div>
      <CTAHero />
      <Container>
        <div className="bg-white">
          <div className="px-6 lg:px-8 lg:mt-8">
            <div>
              <h2 className="text-lg font-semibold leading-7 text-blue-600">
                Sign up
              </h2>
              <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                Choose your supplier type
              </p>
            </div>
            <p className="mt-4 mb-6 text-lg leading-8 text-gray-600">
              Simple, transparent pricing that grows with you. Try any plan free
              for 30 days.
            </p>
            <div className="grid grid-cols-2 gap-x-10">
              <div className="border shadow rounded-lg">
                <div className="border-b p-6 flex gap-4">
                  <span className="size-10 border flex items-center justify-center rounded-lg shadow-sm">
                    <UserIcon className="size-6" />
                  </span>
                  <div>
                    <p>You are an individual representation your business</p>
                    <h4 className="text-2xl font-bold mt-2 text-black">Individual</h4>
                  </div>
                </div>
                <div className="p-6">
                  <Button
                    href="/supplier-register-individual"
                    className={"w-full"}
                  >
                    Choose Individual
                  </Button>
                </div>
              </div>
              <div className="border shadow rounded-lg">
                <div className="border-b p-6 flex gap-4">
                  <span className="size-10 border flex items-center justify-center rounded-lg shadow-sm">
                    <BuildingOffice2Icon className="size-6" />
                  </span>
                  <div>
                    <p>You are representation your business as corporate</p>
                    <h4 className="text-2xl font-bold mt-2 text-black">Corporate</h4>
                  </div>
                </div>
                <div className="p-6">
                  <Button
                    href="/supplier-register-corporate"
                    className={"w-full"}
                  >
                    Choose Corporate
                  </Button>
                </div>
              </div>
            </div>
            {/* <div className="lg:mt-16 mt-28 flow-root">
              <div className="isolate -mt-16 grid max-w-sm grid-cols-1 gap-y-8 sm:mx-auto lg:mt-0 lg:max-w-none lg:grid-cols-2 lg:gap-8">
                {tiers.map((tier) => (
                  <SupplierPlan {...tier} key={tier.id} />
                ))}
              </div>
            </div> */}
          </div>
        </div>
      </Container>
    </div>
  );
}
